import {Link} from 'react-router-dom';
const ResetPasswordLink = (props)=>{
    return (
        
        <div>
            <Link to="/resetpassword">Forgot Password</Link>
        </div>
    );
}
export default ResetPasswordLink;